<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="60%">
      <div class="card-head-no">
        <div class="device">
          进线设备：
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <el-button type="text" style="padding: 0px; font-size: 10px; color: #909399">点击跳转详情</el-button>
            </div>
            <div>1A#1变压器</div>
          </el-tooltip>
        </div>
        <div class="device">
          出线设备：
          <el-tooltip placement="bottom" effect="light">
            <div slot="content">
              <el-button type="text" style="padding: 0px; font-size: 10px; color: #909399">点击跳转详情</el-button>
            </div>
            <div>1A#1A-4011:#1T低压进线开关</div>
          </el-tooltip>
        </div>
      </div>
      <div>
        <div id="myEcharts" ref="myEcharts" :style="{ height: 400 + 'px' }"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as echarts from "echarts";
  var myChart;
  export default {
    name: "lossCurve",
    data () {
      return {
        title: "",
        dialogVisible: false,
        option: {
          title: {
            text: "【"+"1A 2号变压器"+"】损耗曲线",
            subtext: "线损：7.68kwh 耗损率：0.02%",
            bottom: "0%",
            left: "center",
          },
          tooltip: {
            trigger: "axis",
            show: true,
            confine: true,
            formatter: function(params) {
              let data=0;
              let result=params[0].name;
              params.forEach(function(item) {
                result+="<br/>";
                result+=
                  '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:'+
                  item.color+
                  '"></span>';
                result+=item.seriesName+"：";
                result+=isNaN(item.value)? 0:item.value+" KWh";
                data+=item.data;
              });
              result+="<br/>";
              result+="<span>线损："+data+"kwh</span>";
              result+="<br/>";
              result+="<span>损耗率：1%</span>";
              return result;
            },
          },
          legend: {
            selectedMode: false,
            data: ["进线总量","出线总量"],
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "15%",
            containLabel: true,
          },
          toolbox: {
            feature: {
              saveAsImage: {},
            },
          },
          xAxis: {
            type: "category",
            data: [],
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            name: "用电量(kwh)",
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#f5f5f5"],
                width: 1,
                type: "solid",
              },
            },
          },
          series: [
            {
              name: "进线总量",
              type: "line",
              data: [120,132,101,134,90,230,210],
              smooth: true,
              showSymbol: false,
              itemStyle: {
                normal: {
                  color: "rgb(45, 185, 227)",
                  lineStyle: {
                    color: "rgb(45, 185, 227)", //改变折线颜色
                  },
                },
              },
            },
            {
              name: "出线总量",
              type: "line",
              data: [220,182,191,234,290,330,310],
              smooth: true,
              showSymbol: false,
              itemStyle: {
                normal: {
                  color: "rgb(255, 135, 123)",
                  lineStyle: {
                    color: "rgb(255, 135, 123)", //改变折线颜色
                  },
                },
              },
            },
          ],
        },
      };
    },
    mounted () {
      // this.initn()
    },
    methods: {
      initn () {
        let item="";
        let title="";
        let date=new Date();
        let month=parseInt(date.getMonth()+1);
        let day=date.getDate();
        if(month<10) month="0"+month;
        if(day<10) day="0"+day;
        item=date.getFullYear()+"-"+month+"-"+day;
        date.setDate(day+1);
        title=
          "("+
          date.getFullYear()+
          "-"+
          month+
          "-"+
          day+
          " 00:00"+
          "~"+
          month+
          "-"+
          date.getDate()+
          " 00:00 )";
        let data=[];
        for(let i=0;i<24;i++) {
          if(i<10) {
            data.push(item+" "+0+i+":00");
          } else {
            data.push(item+" "+i+":00");
          }
        }
        this.title="【"+"1A 2号变压器"+"】损耗曲线";
        this.option.title.text="【"+"1A 2号变压器"+"】损耗曲线"+title;
        this.option.xAxis.data=data;
        this.title="【"+"1A 2号变压器"+"】损耗曲线";
        this.dialogVisible=true;
        setTimeout((v) => {
          myChart=echarts.init(document.getElementById("myEcharts"));
          myChart.setOption(this.option);
          myChart.resize();
          $(window).resize(function() {
            myChart.resize();
          });
        },500);
      },
    },
  };
</script>

<style scoped>
  .card-head-no {
    color: #909399;
  }

  .card-head-no .device {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-bottom: 5px;
    font-size: 14px;
  }
</style>